import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import { message, Modal } from "@pionex-web-kit/components";
import { VerifyCodeAction } from "bu_account_js_sdk";
import React, { forwardRef, useCallback, useImperativeHandle, useRef, useState } from "react";
import { useTranslators } from "../hooks/Locale";
import { parseAccountError } from "../utils/parseAccountError";
import { CodeInputGroup } from "./CodeInputGroup";
import { jsx as _jsx } from "react/jsx-runtime";
export var CodeInputModal = /*#__PURE__*/forwardRef(function (props, ref) {
  var resetOtpUrl = props.resetOtpUrl;
  var _useTranslators = useTranslators(),
    $st = _useTranslators.$st;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    otpErrorLink = _useState2[0],
    setOtpErrorLink = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    visible = _useState4[0],
    setVisible = _useState4[1];
  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    loading = _useState6[0],
    setLoading = _useState6[1];
  var _useState7 = useState({
      action: VerifyCodeAction.login,
      verifyTypes: []
    }),
    _useState8 = _slicedToArray(_useState7, 2),
    params = _useState8[0],
    setParams = _useState8[1];
  var onOkRef = useRef();
  var onCancelRef = useRef();
  var onOk = useCallback(function (verifyData) {
    var _onOkRef$current;
    setLoading(true);
    (_onOkRef$current = onOkRef.current) === null || _onOkRef$current === void 0 ? void 0 : _onOkRef$current.call(onOkRef, verifyData);
  }, []);
  var onCancel = useCallback(function () {
    var _onCancelRef$current;
    setVisible(false);
    (_onCancelRef$current = onCancelRef.current) === null || _onCancelRef$current === void 0 ? void 0 : _onCancelRef$current.call(onCancelRef);
  }, []);
  var showErrorTips = useCallback(function () {
    var _error$data, _error$message;
    var error = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    if ([-109903, -4212].includes(error.code) && !((_error$data = error.data) !== null && _error$data !== void 0 && _error$data.un_used)) {
      onCancel();
    }
    message.error(parseAccountError(error, $st));
    setOtpErrorLink(error.code === -109903 && ((_error$message = error.message) === null || _error$message === void 0 ? void 0 : _error$message.includes("type=otp")));
  }, [$st, onCancel]);
  useImperativeHandle(ref, function () {
    return {
      request: function request(params) {
        onOkRef.current = params.onOk;
        if (params.onCancel) {
          onCancelRef.current = params.onCancel;
        }
        setLoading(false);
        var error = params.error,
          _params$errorTips = params.errorTips,
          errorTips = _params$errorTips === void 0 ? true : _params$errorTips;
        if (!error) {
          setParams(params.params);
          setVisible(true);
          setOtpErrorLink(false);
        } else if (errorTips) {
          showErrorTips(error);
        }
      },
      retry: function retry() {
        var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        if (params.onOk) {
          onOkRef.current = params.onOk;
        }
        var error = params.error;
        if (error) {
          showErrorTips(error);
        }
        setLoading(false);
      },
      dismiss: function dismiss() {
        setLoading(false);
        setVisible(false);
      }
    };
  }, [onCancel]);
  var _useState9 = useState(false),
    _useState10 = _slicedToArray(_useState9, 2),
    sendCodeValidate = _useState10[0],
    setSendCodeValidate = _useState10[1];
  return /*#__PURE__*/_jsx(Modal, {
    centered: true,
    destroyOnClose: true,
    maskClosable: false,
    visible: visible,
    closable: false,
    mobileSwitch: "drawer",
    confirmLoading: loading,
    okButtonProps: {
      disabled: loading || sendCodeValidate,
      htmlType: "submit",
      form: "codeInputForm"
    },
    okText: $st("button_confirm"),
    onCancel: onCancel,
    title: $st("google_authenticator_verify_title"),
    children: /*#__PURE__*/_jsx(CodeInputGroup, {
      params: params,
      verify: onOk,
      otpErrorLink: otpErrorLink,
      onValidateInfo: setSendCodeValidate,
      autoFocus: true,
      resetOtpUrl: resetOtpUrl,
      changeVerificationDropdownProps: props.changeVerificationDropdownProps
    })
  });
});